import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconProgress25: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconProgress25"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M20 12C20 7.58172 16.4183 4 12 4V12H20Z" fill="currentColor"/></CentralIconBase>;
});

export default IconProgress25;
